import React, { forwardRef } from 'react';

const IcStatusDisconnected = forwardRef((properties, ref) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 18 18",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties,
  ref
}, /* @__PURE__ */ React.createElement("rect", {
  height: "6",
  rx: "3",
  stroke: "var(--color-status-device-disconnected)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  width: "12",
  x: "3",
  y: "6"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M3 15L15 3",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "4.5"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M4.75 13.25L13.25 4.75",
  stroke: "var(--color-status-device-disconnected)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
})));

export { IcStatusDisconnected };
//# sourceMappingURL=ic-status-disconnected.js.map
